module.exports = __webpack_public_path__ + "assets/secondo.36ebdf43.svg";